import { render, staticRenderFns } from "./djgorder.vue?vue&type=template&id=37643b3f&scoped=true&"
import script from "./djgorder.vue?vue&type=script&lang=js&"
export * from "./djgorder.vue?vue&type=script&lang=js&"
import style0 from "./djgorder.vue?vue&type=style&index=0&id=37643b3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37643b3f",
  null
  
)

export default component.exports